import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/assets/icons/read-more.svg")